import { jsonProperty, Serializable } from "ts-serializable";

export class TipoAnexoConteudo extends Serializable {
  @jsonProperty(Number, null)
  codigo?: number | null = -1;

  @jsonProperty(String, null)
  nome: string = '';
}
